import { StyledTable } from '@/Components/Elements/StyledComponents/Tables'
import React, { Component } from 'react'
import {
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Alert,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    List,
    ListItem,
    Box,
} from '@mui/material'
import LoadingDefault from '../../Elements/Loading/LoadingDefault'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faAsterisk } from '@fortawesome/pro-duotone-svg-icons/faAsterisk'
import { faCheck } from '@fortawesome/pro-duotone-svg-icons/faCheck'
import { faCircle } from '@fortawesome/pro-duotone-svg-icons/faCircle'
import { faEdit } from '@fortawesome/pro-duotone-svg-icons/faEdit'
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons/faTrashAlt'

import ConfirmDeleteDialog from '../ConfirmDeleteDialog'
import DefFieldListForm from '../DefFieldListForm'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import DragAndDropContainer from '../../Elements/DragAndDrop/ContainerDragAndDrop'
import Flag from '../../Elements/Flag.tsx'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { CompactButton } from '@/Components/Elements/StyledComponents/Buttons'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
class DefFieldListSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            multiple:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.multiple === true
                    ? true
                    : false,
            options:
                this.props.item && this.props.item.def_field_lists
                    ? this.props.item.def_field_lists
                    : [],
            error: false,
            newOptionText: null,
            newOptionColor: null,
        }
        this.fetchOptions = this.fetchOptions.bind(this)
        this.sortListOption = this.sortListOption.bind(this)
        this.renderListComponent = this.renderListComponent.bind(this)
    }

    fetchOptions(defFieldId) {
        const kedo = this.props.kedo
        let params = {
            params: {
                defField: defFieldId,
                limit: 500,
            },
        }
        this.setState({
            loading: true,
        })
        kedo.api()
            .getCached(kedo.api().getDefFieldListEndpoint(), params)
            .then((response) => {
                this.setState({
                    options: response.data.results,
                    loading: false,
                })
            })
            .catch((error) => {
                this.setState({
                    error: true,
                    loading: false,
                })
            })
    }

    componentDidMount() {
        if (this.props.item.id) {
            this.fetchOptions(this.props.item.id)
        }
    }

    renderEditOption() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'md'}
                fullWidth
                title={
                    <>
                        {this.props.kedo.t(`Edit list option`)}{' '}
                        {this.state.editOption ?? ''}
                    </>
                }
                onClose={() => this.setState({ editOption: false })}
                headerClose={() => this.setState({ editOption: false })}
                contentProps={{ dividers: true, dense: true }}
            >
                <DefFieldListForm
                    onClose={() => this.setState({ editOption: false })}
                    onSuccess={() => {
                        this.setState({ editOption: false })
                        this.fetchOptions(this.props.item.id)
                    }}
                    kedo={this.props.kedo}
                    defFieldId={this.props.item.id}
                    id={this.state.editOption}
                />
            </AppDialog>
        )
    }

    renderAddOption() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'md'}
                fullWidth
                title={this.props.kedo.t('Add item')}
                onClose={() => this.setState({ addOption: false })}
                headerClose={() => this.setState({ addOption: false })}
                contentProps={{ dividers: true, dense: true }}
            >
                <DefFieldListForm
                    onClose={() => this.setState({ addOption: false })}
                    onSuccess={() => {
                        this.setState({ addOption: false })
                        this.fetchOptions(this.props.item.id)
                    }}
                    kedo={this.props.kedo}
                    defFieldId={this.props.item.id}
                />
            </AppDialog>
        )
    }

    sortListOption(listOptionA, listOptionB) {
        let comparison = 0
        if (listOptionA.rank > listOptionB.rank) {
            comparison = 1
        } else if (listOptionA.rank < listOptionB.rank) {
            comparison = -1
        }
        return comparison
    }
    renderListComponent(item, ref, handlerId, opacity, style) {
        return (
            <TableRow
                ref={ref}
                style={{ ...style, opacity }}
                data-handler-id={handlerId}
                key={item.id}
            >
                <TableCell>{item.id}</TableCell>
                <TableCell>
                    {item.translations?.length > 0 ? (
                        <List disablePadding>
                            {item.translations.map((tItem, tIndex) => (
                                <ListItem
                                    key={tIndex}
                                    sx={{
                                        py: 0,
                                        gap: 1,
                                        '& img, & svg': {
                                            mr: 0,
                                            flexShrink: 0,
                                        },
                                    }}
                                >
                                    <Flag
                                        code={tItem.culture.slice(-2)}
                                        height="12"
                                    />
                                    {tItem.text}
                                </ListItem>
                            ))}
                        </List>
                    ) : null}
                </TableCell>
                <TableCell>
                    {item.color ? (
                        <span>
                            <FontAwesomeIcon
                                style={{
                                    color: item.color,
                                }}
                                icon={faCircle}
                            />
                            &nbsp;
                        </span>
                    ) : null}
                </TableCell>
                <TableCell>{item.rank}</TableCell>
                <TableCell>
                    {item.default ? <FontAwesomeIcon icon={faCheck} /> : null}
                </TableCell>
                <TableCell>
                    {item.settings &&
                    item.settings.roles &&
                    item.settings.roles.length > 0 ? (
                        <FontAwesomeIcon icon={faAsterisk} />
                    ) : null}
                </TableCell>
                <TableCell>
                    <Box display="flex" justifyContent="flex-end" gap={1}>
                        <CompactButton
                            variant="outlined"
                            color="primary"
                            dense
                            onClick={() =>
                                this.setState({ editOption: item.id })
                            }
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </CompactButton>
                        <CompactButton
                            variant="outlined"
                            color="error"
                            dense
                            invert
                            onClick={() =>
                                this.setState({ confirmDeleteOption: item.id })
                            }
                        >
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </CompactButton>
                    </Box>
                </TableCell>
            </TableRow>
        )
    }

    render() {
        const kedo = this.props.kedo
        return (
            <div>
                {this.state.addOption ? this.renderAddOption() : null}
                {this.state.editOption ? this.renderEditOption() : null}
                {this.state.confirmDeleteOption ? (
                    <ConfirmDeleteDialog
                        kedo={kedo}
                        onClose={() => {
                            this.setState({ confirmDeleteOption: false })
                            this.fetchOptions(this.props.item.id)
                        }}
                        label={'position'}
                        url={
                            kedo.api().getDefFieldListEndpoint() +
                            '/' +
                            this.state.confirmDeleteOption
                        }
                    />
                ) : null}
                <h3>{kedo.t('Settings')}</h3>
                <FormControl component="fieldset" fullWidth>
                    <FormInputLabel component="legend">
                        {kedo.t('Multiple')}
                    </FormInputLabel>
                    <RadioGroup
                        row
                        value={this.state.multiple ? 'yes' : 'no'}
                        onChange={(e) => {
                            const val = e.target.value === 'yes'
                            this.setState({ multiple: val })
                            this.props.onChange('multiple', val)
                        }}
                    >
                        <FormControlLabel
                            size="small"
                            value="yes"
                            control={<Radio />}
                            label={kedo.t('Yes')}
                        />
                        <FormControlLabel
                            size="small"
                            value="no"
                            control={<Radio />}
                            label={kedo.t('No')}
                        />
                    </RadioGroup>
                </FormControl>
                <br />
                <TableContainer component={Paper}>
                    <StyledTable size="small" striped>
                        <TableHead>
                            <TableRow
                                sx={{
                                    '& .MuiTableCell-head, th': {
                                        textAlign: 'left',
                                        fontWeight: 'bold',
                                    },
                                }}
                            >
                                <TableCell colSpan={7}>
                                    <FormInputLabel>
                                        {kedo.t('Options')}
                                    </FormInputLabel>
                                    <CompactButton
                                        sx={{ float: 'right' }}
                                        onClick={() =>
                                            this.setState({ addOption: true })
                                        }
                                    >
                                        <FontAwesomeIcon icon={faPlus} />
                                    </CompactButton>
                                </TableCell>
                            </TableRow>
                            <TableRow
                                sx={{
                                    width: '100%',
                                    '& .MuiTableCell-head, th': {
                                        textAlign: 'left',
                                        fontWeight: 'bold',
                                    },
                                }}
                            >
                                <TableCell>#</TableCell>
                                <TableCell>{kedo.t('Text')}</TableCell>
                                <TableCell>{kedo.t('Color')}</TableCell>
                                <TableCell>{kedo.t('Rank')}</TableCell>
                                <TableCell>{kedo.t('Default')}</TableCell>
                                <TableCell>{kedo.t('Visibility')}</TableCell>
                                <TableCell>{kedo.t('Actions')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{}}>
                            {this.state.loading && (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        <LoadingDefault />
                                    </TableCell>
                                </TableRow>
                            )}
                            {!this.props.item?.id && (
                                <TableRow>
                                    <TableCell colSpan={7}>
                                        <Alert severity="info">
                                            {kedo.t('Save this item first')}
                                        </Alert>
                                    </TableCell>
                                </TableRow>
                            )}
                            {this.state.error && (
                                <TableRow>
                                    <TableCell colSpan={7}>
                                        <Alert severity="warning">
                                            {kedo.t('Could not load data')}
                                        </Alert>
                                    </TableCell>
                                </TableRow>
                            )}
                            <DndProvider backend={HTML5Backend}>
                                <DragAndDropContainer
                                    items={this.state.options.sort(
                                        this.sortListOption
                                    )}
                                    onSortItems={(items) => {
                                        items.forEach(
                                            (item, idx) => (item.rank = idx)
                                        )
                                        this.setState({ options: items })
                                        this.props.onChange('rank', items)
                                    }}
                                    Component={this.renderListComponent}
                                />
                            </DndProvider>
                        </TableBody>
                    </StyledTable>
                </TableContainer>
            </div>
        )
    }
}

export default DefFieldListSettings
